<template>
  <report-section title="氧减事件统计" :titleStyle="{ color: '#000000', marginTop: '-60px',fontSize: '18px' ,fontWeight:'bold' }">
    <template v-slot:content>
      <div class="section-blood-oxygen-table">
        <table class="table">
          <thead>
            <tr class="table-row table-header">
              <td class="table-row-item table-header-item">血氧范围</td>
              <td class="table-row-item table-header-item">次数</td>
              <td class="table-row-item table-header-item">总占比</td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`95%≤SpO2${signal}100%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess100TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess100RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`90%≤SpO2${signal}95%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess95TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess95RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`85%≤SpO2${signal}90%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess90TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess90RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`80%≤SpO2${signal}85%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess85TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess85RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`75%≤SpO2${signal}80%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess80TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess80RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`70%≤SpO2${signal}75%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess75TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess75RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`65%≤SpO2${signal}70%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess70TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess70RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`60%≤SpO2${signal}65%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess65TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess65RatioStr }}
              </td>
            </tr>
            <tr class="table-row">
              <td
                class="table-row-item table-row-item-bold"
                v-text="`SpO2${signal}60%`"
              ></td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess60TimesStr }}
              </td>
              <td class="table-row-item">
                {{ reportDetailModel.oxygenMinusEventLess60RatioStr }}
              </td>
            </tr>
          </thead>
        </table>
      </div>
    </template>
  </report-section>
</template>
      
      <script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";

export default {
  components: {
    ReportSection,
    KeyValueUnit,
  },

  props: {
    reportDetailModel: Object,
  },

  data() {
    return {
      signal: "<",
    };
  },
};
</script>
      
      <style lang="scss" scoped>
.oxygen-minus-event-table-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.table {
  border: 1px solid #707070;

  &-row {
    display: flex;
    justify-content: space-evenly;

    :nth-child(1){
        width: 150px;
    }

    :nth-child(2){
        width: 80px;
    }

    :nth-child(3){
        width: 90px;
    }

    &-item {
      color: black;
      font-size: 16px;
      // font-weight: 400;
      border: 1px solid #707070;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;

      &-bold {
        // 移除数据行第一列的加粗效果
      }
    }
  }
}

// 表头样式
.table-header {
  .table-header-item {
    font-weight: bold;
  }
}

@media print {
  .oxygen-minus-event-table-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
}
</style>